const AttachIcon = (props: any) => (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect width='40' height='40' rx='16' fill='#3BA745' />
    <path
      d='M19.001 28V19.4131L16.707 21.707C16.3165 22.0975 15.6835 22.0975 15.293 21.707C14.9025 21.3165 14.9025 20.6835 15.293 20.293L19.2939 16.293L19.3701 16.2246C19.7629 15.9043 20.3419 15.9269 20.708 16.293L24.709 20.293L24.7773 20.3691C25.0977 20.7619 25.075 21.3409 24.709 21.707C24.3429 22.0731 23.7639 22.0958 23.3711 21.7754L23.2949 21.707L21.001 19.4131V28C21.001 28.5523 20.5533 29 20.001 29C19.4487 29 19.001 28.5523 19.001 28ZM27.001 13L27.1035 13.0049C27.6077 13.0562 28.001 13.4823 28.001 14C28.001 14.5177 27.6077 14.9438 27.1035 14.9951L27.001 15H13C12.4477 15 12 14.5523 12 14C12 13.4477 12.4477 13 13 13H27.001Z'
      fill='white'
    />
  </svg>
);

export default AttachIcon;
